module.exports = __webpack_public_path__ + "img/scene_travel.ece38e95.webp";